// tslint:disable
/**
 * AgoraPay API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */
export enum Role {
    Invalid = 'Invalid',
    System = 'System',
    Admin = 'Admin',
    Basic = 'Basic',
    BasicMobile = 'BasicMobile',
    ReportUploader = 'ReportUploader'
}



